import { render, staticRenderFns } from "./NormalButton.vue?vue&type=template&id=76d16e2b&scoped=true&"
import script from "./NormalButton.vue?vue&type=script&lang=ts&"
export * from "./NormalButton.vue?vue&type=script&lang=ts&"
import style0 from "./NormalButton.vue?vue&type=style&index=0&id=76d16e2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d16e2b",
  null
  
)

export default component.exports